module.exports = __webpack_public_path__ + "img/1482133948355.15dd3c28.jpg";